import { createPrng } from '@play-co/replicant';
import {
  CardPackID,
  cardPackConfig,
  cardDropProbabilities,
} from './cardpack.ruleset';
import { CardRarity, CardId, cardsCatalog } from '../cards/cards.ruleset';
import { weightedRandom } from '../utils/random';

export function getCardPackContents(
  boxId: CardPackID,
  playerId: string,
  now: number,
) {
  const random = createPrng(`${boxId}-${playerId}-${now}`);

  const config = cardPackConfig[boxId];

  const cardRarities: CardRarity[] = [];

  if (config.guaranteedCardTier) {
    cardRarities.push(config.guaranteedCardTier);
  }

  while (cardRarities.length < config.cardsInside) {
    const index = weightedRandom(Object.values(cardDropProbabilities), random);
    cardRarities.push(
      parseInt(Object.keys(cardDropProbabilities)[index]) as CardRarity,
    );
  }

  const cardIds = cardRarities.map((rarity) => {
    const properCards = Object.entries(cardsCatalog).filter(
      ([_, data]) => data.rarity === rarity,
    );

    const card = properCards[(random() * properCards.length) | 0][0];

    return card as CardId;
  });

  return cardIds;
}
